export default __webpack_public_path__ + "static/media/sanathan_logo.c5d62442.png";